"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var SlideGenerator_1 = require("../SlideGenerator");
var PreloadApi_1 = require("../PreloadApi");
var PreloadableItemComponent_1 = require("./PreloadableItemComponent");
var GalleryComponent = /** @class */ (function (_super) {
    __extends(GalleryComponent, _super);
    function GalleryComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.isDown = false;
        _this.downX = 0;
        _this.downY = 0;
        _this.isVertical = false;
        _this.isHorizontal = false;
        _this.state = __assign({}, _this.getGalleryPosition(300, 400, _this.props.items, _this.props.slideIndex || 0, -1));
        return _this;
    }
    GalleryComponent.prototype.componentDidMount = function () {
        this.preloadSize(this.state);
    };
    GalleryComponent.prototype.componentWillReceiveProps = function (newProps) {
        var slideIndex = newProps.slideIndex;
        // tslint:disable-next-line:max-line-length
        var slide = this.getGalleryPosition(newProps.width, newProps.height, this.state.items, slideIndex, -1, false);
        this.setState(__assign({}, slide));
        this.preloadSize(this.state);
    };
    GalleryComponent.prototype.next = function () {
        var i = (0, SlideGenerator_1.circularIndex)(this.state.film.slideItems.length, this.state.film.slideIndex, 1);
        this.snapToNearest(i);
    };
    GalleryComponent.prototype.prev = function () {
        var i = (0, SlideGenerator_1.circularIndex)(this.state.film.slideItems.length, this.state.film.slideIndex, -1);
        this.snapToNearest(i);
    };
    GalleryComponent.prototype.setSlideLoading = function (originalIndexes, state) {
        var newItems = state.items.map(function (it, i) {
            if (originalIndexes.indexOf(i) === -1)
                return it;
            return __assign(__assign({}, it), { loading: true });
        });
        var newState = __assign(__assign({}, state), { items: newItems });
        this.setState(newState);
        return newState;
    };
    GalleryComponent.prototype.setSlideLoaded = function (indexes, state) {
        var newItems = state.items.map(function (it, i) {
            if (indexes.indexOf(i) === -1)
                return it;
            return __assign(__assign({}, it), { loaded: true });
        });
        this.setState({
            items: newItems
        });
    };
    GalleryComponent.prototype.setSlideSizesLoaded = function (sizes) {
        var newItems = this.state.items.map(function (it, i) {
            if (sizes.map(function (it) { return it.index; }).indexOf(i) === -1)
                return it;
            var n = sizes.findIndex(function (it) { return it.index === i; });
            return __assign(__assign({}, it), { width: sizes[n].width, height: sizes[n].height });
        });
        var slide = this.getGalleryPosition(this.state.width, this.state.height, newItems, -1, this.state.film.slideIndex, false);
        this.setState(__assign({}, slide));
        return slide;
    };
    GalleryComponent.prototype.doPreloadSrc = function (i) {
        var src = this.state.items[i].src;
        if ((0, PreloadApi_1.isVideo)(src)) {
            return (0, PreloadApi_1.getVideoDimension)(src);
        }
        return (0, PreloadApi_1.getImageDimension)(src);
    };
    GalleryComponent.prototype.doGetThumbSize = function (i, thumb) {
        return (0, PreloadApi_1.getImageDimension)(thumb).then(function (size) { return ({
            width: size.width,
            height: size.height,
            index: i
        }); });
    };
    GalleryComponent.prototype.preloadSrc = function (state) {
        var _this = this;
        var originalIndexes = state.film.slideItems
            .filter(function (it) { return it.seen && !state.items[it.originIndex].loading; })
            .map(function (it) { return it.originIndex; })
            .filter(function (x, i, a) { return a.indexOf(x) === i; });
        var newState = this.setSlideLoading(originalIndexes, state);
        Promise.all(originalIndexes.map(function (i) {
            return _this.doPreloadSrc(i);
        })).then(function () {
            _this.setSlideLoaded(originalIndexes, newState);
            if (_this.props.onLoaded && originalIndexes.length) {
                _this.props.onLoaded();
            }
        });
    };
    GalleryComponent.prototype.preloadSize = function (state) {
        var _this = this;
        var originalIndexes = state.film.slideItems
            .filter(function (it) { return it.preview && !state.items[it.originIndex].sizeLoaded; })
            .map(function (it) { return it.originIndex; })
            .filter(function (x, i, a) { return a.indexOf(x) === i; });
        Promise.all(originalIndexes.map(function (i) {
            return _this.doGetThumbSize(i, state.items[i].thumb);
        })).then(function (sizes) {
            var newState = _this.setSlideSizesLoaded(sizes);
            _this.preloadSrc(newState);
        });
    };
    GalleryComponent.prototype.snapToNearest = function (i) {
        var _this = this;
        if (i === void 0) { i = null; }
        var state = this.state;
        var nearest = i === null ? (0, SlideGenerator_1.getNearestSlide)(state.film.slideItems, state.film.offset, state.width, state.center) : i;
        if (nearest === state.film.slideIndex && Math.abs(state.deltaX) > 60) {
            nearest = (0, SlideGenerator_1.circularIndex)(this.state.film.slideItems.length, this.state.film.slideIndex, (this.state.deltaX > 0 ? -1 : 1));
        }
        // tslint:disable-next-line:max-line-length
        var slide = this.getGalleryPosition(this.state.width, this.state.height, this.state.items, -1, nearest);
        this.setState(__assign({}, slide), function () {
            var teleportIndex = slide.film.slideItems[nearest].originIndex;
            setTimeout(function () {
                // tslint:disable-next-line:max-line-length
                var slide2 = _this.getGalleryPosition(_this.state.width, _this.state.height, _this.state.items, teleportIndex, -1, false);
                _this.setState(__assign({}, slide2));
                _this.preloadSize(slide2);
                _this.props.onSlideIndexChanged(teleportIndex);
            }, 200);
        });
    };
    // tslint:disable-next-line:max-line-length
    GalleryComponent.prototype.getGalleryPosition = function (width, height, items, originIndex, slideIndex, animate) {
        if (animate === void 0) { animate = true; }
        var slideItems = (0, SlideGenerator_1.resizeToFit)(items.map(function (it) { return (__assign(__assign({}, it), { width: it.width || 800, height: it.height || 600 })); }), width, height);
        var slides = (0, SlideGenerator_1.fillOffset)((0, SlideGenerator_1.getSlidesFromItems)(width, slideItems, true));
        var film;
        if (originIndex >= 0) {
            film = (0, SlideGenerator_1.getOffsetByOriginalIndex)(slides, width, height, originIndex, true, slideItems);
        }
        else {
            var i = slideIndex > 0 ? slideIndex : 0;
            film = (0, SlideGenerator_1.getOffsetBySlideIndex)(slides, width, height, i, true, slideItems);
        }
        for (var i = 0; i < film.slideItems.length; i = i + 1) {
            var _a = (0, PreloadApi_1.getPreviewState)(film.slideItems[i].originIndex, film, 0), preview = _a.preview, seen = _a.seen;
            film.slideItems[i].preview = preview;
            film.slideItems[i].seen = seen;
        }
        var slide = {
            film: film,
            items: items,
            width: width,
            height: height,
            id: '',
            offset: film.offset,
            shouldAnimate: animate,
            isMoving: false,
            downX: -1,
            downOffset: -1,
            deltaX: 0,
            center: true
        };
        return slide;
    };
    GalleryComponent.prototype.render = function () {
        var _this = this;
        var containerStyle = {
            width: this.state.width,
            height: this.state.height,
            overflow: 'hidden'
        };
        var filmStyle = {
            display: 'block',
            whiteSpace: 'nowrap',
            transform: "translate(".concat(this.state.offset, "px, 0)"),
            transition: this.state.shouldAnimate ? 'transform 200ms ease-out' : 'none',
            cursor: 'grab',
            MozUserSelect: 'none',
            userSelect: 'none',
            touchAction: 'pan-y'
        };
        var onItemClick = function (index) { return function (item) {
            if (item.isCurrent) {
                _this.props.onItemClick(item);
                return;
            }
            _this.snapToNearest(index);
        }; };
        var renderItem = function (it, i) {
            var items = _this.state.items;
            var itemProps = __assign(__assign({}, items[it.originIndex]), { preview: it.preview, width: it.width, height: it.height, loaded: items[it.originIndex].loaded, isCurrent: _this.state.film.slideIndex === i });
            return (React.createElement(PreloadableItemComponent_1["default"], __assign({ key: i }, itemProps, { onItemClick: onItemClick(i) })));
        };
        var onDragStart = function (clientX) {
            _this.setState({
                isMoving: true,
                deltaX: 0,
                downX: clientX,
                downOffset: _this.state.offset
            });
        };
        var onDragEnd = function () {
            _this.setState({
                isMoving: false,
                downX: -1
            });
            if (_this.state.deltaX !== 0)
                _this.snapToNearest();
        };
        var onDragMove = function (clientX) {
            if (!_this.state.isMoving)
                return;
            var deltaX = clientX - _this.state.downX;
            _this.setState({
                deltaX: deltaX,
                offset: _this.state.downOffset + deltaX
            });
        };
        var eventHandlers = {
            onMouseDown: function (event) { return onDragStart(event.clientX); },
            onMouseUp: function () { return onDragEnd(); },
            onMouseMove: function (event) { return onDragMove(event.clientX); },
            onTouchStart: function (event) {
                _this.isVertical = false;
                _this.isHorizontal = false;
                _this.isDown = true;
                _this.downX = event.touches[0].clientX;
                _this.downY = event.touches[0].clientY;
                onDragStart(event.touches[0].clientX);
            },
            onTouchEnd: function () {
                _this.isDown = false;
                _this.downX = 0;
                _this.downY = 0;
                onDragEnd();
            },
            onTouchMove: function (event) {
                if (!_this.isDown)
                    return;
                var x = event.touches ? event.touches[0].clientX : event.touches[0].clientX;
                var y = event.touches ? event.touches[0].clientY : event.touches[0].clientY;
                var deltaX = x - _this.downX;
                var deltaY = y - _this.downY;
                if (!_this.isHorizontal && !_this.isVertical) {
                    if (Math.abs(deltaX) > 20)
                        _this.isHorizontal = true;
                    if (Math.abs(deltaY) > 20)
                        _this.isVertical = true;
                    return;
                }
                if (_this.isVertical)
                    return;
                event.preventDefault();
                onDragMove(event.touches[0].clientX);
            }
        };
        return (React.createElement("div", __assign({ style: containerStyle }, eventHandlers),
            React.createElement("div", { style: filmStyle }, this.state.film.slideItems.map(renderItem))));
    };
    return GalleryComponent;
}(React.Component));
exports["default"] = GalleryComponent;
